import React from 'react'
import { Route } from 'react-router-dom'
import CaidsIndex from './index'
import CaidsResource from './resource'

const CaidsRouter = () => {
  return (
    <>
      <Route path="/ui/caids" element={<CaidsIndex />} />
      <Route path="/ui/caids/:action" element={<CaidsResource />} />
      <Route path="/ui/caids/:id/:action" element={<CaidsResource />} />
    </>
  )
}

export default CaidsRouter
